import { Form } from 'antd'

import BuildingLevelSelect from '../BuildingLevelSelect'


const BuildingLevelSelectField = ({ name, label, required, disabled }) => {
  return (
    <Form.Item label={label} name={name} rules={[{ required: required }]}>
      <BuildingLevelSelect required={required} disabled={disabled} />
    </Form.Item>
  );
}

BuildingLevelSelectField.getValue = (values) => {
  return values;
}

BuildingLevelSelectField.getDisplayValue = (values, config) => {
  return values
};

export default BuildingLevelSelectField
